// import Reacct from 'react'
import { Navbar } from "../../Components/Navbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
// import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import React, { useState } from "react";
import "./finalisefs.css";
import Preview from "./Preview";
import ExportExcel from "./exportExcel";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddHeaders from "./headers";
import { useHistory } from "react-router-dom";
import AddFooters from "./footers";
import { motion } from "framer-motion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import standalonecss from "../../myfin_v2/css/standalone.module.css"
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import CreatePackageModal from "../../myfin_v2/components/bookclosure/CreatePackageModal";
import { Button } from "../../myfin_v2/elements/Button";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusBlack.svg";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { getPopulateFSExportFSApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
// import "./finalisefs.css";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const FinaliseFs = () => {
  const [headers, setHeaders] = useState([]);
  const [footers, setFooters] = useState([]);
  const [exportPages, setExportPages] = useState([]);

  const [uploadedUrl, setUploadedUrl] = useState({
    image1: null,
    image2: null,
    image3: null,
    sheet1: [],
    sheet2: [],
    sheet3: [],
  });

  const [headerCount, setHeaderCount] = useState([0]);
  const [footerCount, setFooterCount] = useState([0]);
  const project_id = localStorage.getItem("project_id"); 
  // const project_id = "6926c0af2325c750306470a0";
  console.log("project_id", project_id);

  const popHeaderCount = (index) => {
    setHeaderCount(headerCount.filter((_, idx) => idx !== index));
    setHeaders(headers.filter((_, idx) => idx !== index));
  }

  const popFooterCount = (index) => {
    setFooterCount(footerCount.filter((_, idx) => idx !== index));
    setFooters(footers.filter((_, idx) => idx !== index));
  }

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const units_values = [
    "Whole Number",
    "Hundreds",
    "Thousands",
    "Lakhs",
    "Crores",
    "Millions",
  ];
  const decimal_values = [0, 1, 2, 3];

  const [unit, setUnit] = useState(null);
  const [decimal, setDecimal] = useState(null);
  const history = useHistory();

  const handleNavigateBack = () => {
    history.push("/financialstatement");
  }

  const handleUnitDecimal = (e) => {
    if (e.target.name === "unit") {
      setUnit(e.target.value);
    } else {
      setDecimal(e.target.value);
    }
  };

  const uploadImages = (imageUrl, name) => {
    setUploadedUrl((prevItems) => {
      return {
        ...prevItems,
        [name]: imageUrl,
      };
    });
  };

  const exportFS = (exportAs) => {
    const params = {
      projectID: project_id,
      fileType: exportAs,
    };

    getPopulateFSExportFSApiHandler(params)
      .then((response) => {
        const blob = new Blob(
          [response.data],
          {
            type:
              exportAs === "pdf"
                ? "application/pdf"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

        const fileUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileUrl;

        downloadLink.download =
          exportAs === "pdf"
            ? `FS_${project_id}.pdf`
            : `FS_${project_id}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();

        downloadLink.remove();
        window.URL.revokeObjectURL(fileUrl);
      })
      .catch((error) => {
        console.error("exportFS error:", error);
      });
  };

  const sampleHeaders = [
    "Balance Sheet",
    "P & L",
    "Cashflow",
    "Cashflow Working",
    "Socie",
    "General Notes",
    "Balancesheet Notes",
    "P & L Notes",
    "Disclosures",
    "Disclosure Checklist",
    "All Pages",
  ];

  const handleExportPages = (e) => {
    setExportPages((prevValue) => {
      if (e.target.checked) {
        return [
          ...prevValue,
          e.target.value
        ]
      } else {
        return prevValue.filter(item => item !== e.target.value);
      }
    })
  }

  const handleHeaders = (e, headerNumber) => {
    let value = e.target.value;
    setHeaders((prevHeaders) => {
      // Check if the header already exists
      const headerExists = prevHeaders.some(header => header.header === headerNumber);

      if (headerExists) {
        // If header exists, update its value
        return prevHeaders.map(header =>
          header.header === headerNumber ? { ...header, value: value } : header
        );
      } else {
        // If header does not exist, add it
        return [...prevHeaders, { header: headerNumber, value: value, sheets: [] }];
      }
    });
  };

  const handleImages = (image_url, headerNumber) => {
    setHeaders((prevValue) => {
      const headerExists = prevValue.some(header => header.header === headerNumber);
      if (headerExists) {
        return prevValue.map(header =>
          header.header === headerNumber ? { ...header, image: image_url } : header
        )
      } else {
        return [...prevValue, { header: headerNumber, image: image_url }];
      }
    })
  }

  const handleFooters = (e, footerNumber) => {
    let value = e.target.value;
    setFooters((prevFooters) => {
      // Check if the footer already exists
      const footerExists = prevFooters.some(footer => footer.footer === footerNumber);

      if (footerExists) {
        // If footer exists, update its value
        return prevFooters.map(footer =>
          footer.footer === footerNumber ? { footer: footerNumber, value: value, sheets: footer.sheets } : footer
        );
      } else {
        // If footer does not exist, add it
        return [...prevFooters, { footer: footerNumber, value: value, sheets: [] }];
      }
    });
  };

  const handleCheckBox = (e, headerNumber) => {
    const { checked, value } = e.target;
    if (headerCount.length > 1 && value === 'All Pages') {
      alert("You can't select it, as multiple headers opened");
      return false
    }
    if (checked && headers.some(item => item.sheets.includes(value))) {
      alert("its already checked in header");
      return false
    }
    setHeaders((prevHeaders) => {
      // Check if the header already exists
      const headerExists = prevHeaders.some(header => header.header === headerNumber);

      if (headerExists) {
        // If header exists, update or add the sheet
        return prevHeaders.map(header => {
          if (header.header === headerNumber) {
            const sheetExists = header.sheets.includes(value);
            if (checked) {
              return {
                ...header,
                sheets: sheetExists ? header.sheets : [...header.sheets, value]
              };
            } else {
              return {
                ...header,
                sheets: !sheetExists ? header.sheets : header.sheets.filter((head) => head !== value)
              };
            }

          }
          return header;
        });
      } else {
        // If header does not exist, add it with the new sheet
        return [...prevHeaders, { header: headerNumber, value: '', sheets: [value] }];
      }
    });
  };

  const handleFooterCheckBox = (e, footerNumber) => {
    const { checked, value } = e.target;
    if (footerCount.length > 1 && value === 'All Pages') {
      alert("You can't select it, as multiple footers opened");
      return false
    }
    if (checked && footers.some(item => item.sheets.includes(value))) {
      alert("its already checked in footer");
      return false
    }
    setFooters((prevFooters) => {
      // Check if the footer already exists
      const footerExists = prevFooters.some(footer => footer.footer === footerNumber);

      if (footerExists) {
        // If header exists, update or add the sheet
        return prevFooters.map(footer => {
          if (footer.footer === footerNumber) {
            const sheetExists = footer.sheets.includes(value);
            if (checked) {
              return {
                ...footer,
                sheets: sheetExists ? footer.sheets : [...footer.sheets, value]
              };
            } else {
              return {
                ...footer,
                sheets: !sheetExists ? footer.sheets : footer.sheets.filter((foot) => foot !== value)
              };
            }

          }
          return footer;
        });
      } else {
        // If footer does not exist, add it with the new sheet
        return [...prevFooters, { footer: footerNumber, value: '', sheets: [value] }];
      }
    });
  };

    // { link: "/financialstatement" },

  const breadcrumbItems = [
    { link: "/myfinV2/standalonefs" },
    { label: "Finalise your Financial Statements", link: "", className: "headerLable" },
  ];

  return (
    <>



      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "95vh", overflowY: "hidden" }} >
            {/* <BookcluosureNav bookClosureId={bookClosureId} setCreatePackageModal={setCreatePackageModal} setSavePresetModal={setSavePresetModal} selectedEntries={selectedEntries} entries={entries} /> */}
            <div className="fscp-header">
              <Breadcrumb style="margin-right:auto"
                addCls={"bgClr1"}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as Excel"
                onClick={() => { exportFS("excel") }}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as PDF"
                onClick={() => { exportFS("pdf") }}
              />
            </div>

            <div className="mx-3">
              <div className={standalonecss.finaliseFSDiv}
              >
                <div className="d-flex mt-4 ml-3" style={{ gap: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "210px",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="unit-value-select-label"
                        sx={{
                          "&.Mui-focused": {
                            color: "#B3C0BD",
                          },
                          fontSize: "14px",
                          marginTop: '-5px',
                          fontWeight: "500",
                          color: "#B3C0BD"
                        }}>
                        Units
                      </InputLabel>
                      <Select
                        labelId="unit-value-select-label"
                        id="unit-value-select"
                        value={unit}
                        label="Units"
                        name="unit"
                        onChange={handleUnitDecimal}
                        IconComponent={ExpandMoreIcon}
                        sx={{
                          width: "200px",
                          height: "40px",
                          padding: '10px',
                          paddingLeft: '0px',
                          backgroundColor: "#F4FAF5",
                          borderRadius: "10px",
                          fontSize: "14px",
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",   // vertical center
                            padding: "0 12px",      // nice left/right padding
                            height: "100%",         // make it stretch to match height
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                        }}
                      >
                        {units_values.map((item, key) => (
                          <MenuItem value={item} key={key}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "250px",
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="decimal-value-select-label"
                          sx={{
                            "&.Mui-focused": {
                              color: "#B3C0BD",
                            },
                            fontSize: "14px",
                            marginTop: '-5px',
                            fontWeight: "500",
                            color: "#B3C0BD"
                          }}>
                          Decimals
                        </InputLabel>
                        <Select
                          labelId="decimal-value-select-label"
                          id="decimal-value-select"
                          value={decimal}
                          label="Decimals"
                          name="decimal"
                          onChange={handleUnitDecimal}
                          IconComponent={ExpandMoreIcon}
                          sx={{
                            width: "200px",
                            height: "40px",
                            padding: '10px',
                            paddingLeft: '0px',
                            backgroundColor: "#F4FAF5",
                            borderRadius: "10px",
                            fontSize: "14px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                          }}
                        >
                          {decimal_values.map((item, key) => (
                            <MenuItem value={item} key={key}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>
                <div className="p-3">
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      <span className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>Header</span>
                    </div>
                    {headerCount.map((_, idx) => (
                      <AddHeaders
                        sampleHeaders={sampleHeaders}
                        headers={headers}
                        handleCheckBox={handleCheckBox}
                        handleHeaders={handleHeaders}
                        uploadImages={handleImages}
                        close={idx}
                        popHeaderCount={popHeaderCount}
                        key={idx}
                      />
                    ))}
                    {!headers.some(item => item.sheets.includes('All Pages')) &&
                      <div className={`ml-2 ${commoncss.clickable}`} onClick={() => setHeaderCount([...headerCount, getRandomInt(1, 9)])}>
                        <PlusIcon height={18} width={18} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Header</span>
                      </div>
                    }
                  </Card>
                </div>
                <div className="p-3">
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      <span className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>Footer</span>
                    </div>
                    {footerCount.map((_, idx) => (
                      <AddFooters
                        sampleFooters={sampleHeaders}
                        Footers={footers}
                        handleCheckBox={handleFooterCheckBox}
                        handleFooters={handleFooters}
                        uploadImages={uploadImages}
                        close={idx}
                        popFooterCount={popFooterCount}
                        key={idx}
                      />
                    ))}
                    {!footers.some(item => item.sheets.includes('All Pages')) &&
                      <div className={`ml-2 ${commoncss.clickable}`} onClick={() => setFooterCount([...footerCount, getRandomInt(1, 9)])}>
                        <PlusIcon height={18} width={18} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Footer</span>
                      </div>
                    }
                  </Card>
                </div>
                <div className="p-3">
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      <span className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>Export Pages</span>
                    </div>
                    <CardContent>
                      <div className="d-flex flex-wrap p-2 py-3" style={{ gap: "10px" }}>
                        {sampleHeaders.map((header, index) => (
                          <div
                          >
                            <input type="checkbox"
                              name="sheet1"
                              value={header}
                              onChange={handleExportPages}
                              checked={
                                exportPages.includes(header) || exportPages.includes('All Pages') || false
                              }
                              className={adminPortalCss.customCheckbox}
                            /> <span className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs16}`}>{header}</span>
                          </div>
                        ))}
                      </div>
                    </CardContent>
                  </Card>
                </div>
              </div>
            </div>
          </motion.div>
        </div >
      </div >
    </>
  );
};

export default FinaliseFs;
